<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Admins</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Admins
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h4>Admins</h4>
                    <div class="d-flex">
                        <download-excel
                            ref="exporter-csv"
                            v-show="false"
                            type="csv"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Admins_Report.csv'"
                        />
                        <download-excel
                            ref="exporter-xls"
                            v-show="false"
                            :data="exportRows"
                            :export-fields="exportFields"
                            :name="'Admins_Report.xls'"
                        />
                        <a href="#" @click.prevent="exportTableData('admin.admins.index', {}, 'csv')" class="export-link mr-2">
                            <i class="fas fa-file-csv"></i> Export to CSV
                        </a>
                        <a href="#" @click.prevent="exportTableData('admin.admins.index', {}, 'xls')" class="export-link text-warning">
                            <i class="fa fa-file-excel-o"></i> Export to Excel
                        </a>
                    </div>
                </div>

                <div class="card-body">
                    <form>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Name</label>
                                    <input name="search" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.name">
                                    <template v-if="errors.name">
                                        <small class="text-danger" v-for="error in errors.name">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Email</label>
                                    <input name="order_no" id="category" class="form-control form-control-sm"
                                           type="text"
                                           v-model="filters.email">
                                    <template v-if="errors.email">
                                        <small class="text-danger" v-for="error in errors.email">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="category">By Store</label>
                                    <select name="store" class="form-control form-control-sm"
                                            v-model="filters.store">
                                        <option :value="null" :selected="filters.store==null">All</option>
                                        <option v-for="store in stores" :key="store.id"
                                                :value="store.id">
                                            {{ store.name }}
                                        </option>
                                    </select>
                                    <template v-if="errors.store">
                                        <small class="text-danger" v-for="error in errors.store">
                                            {{ error }}
                                        </small>
                                        <br>
                                    </template>
                                </div>
                            </div>
                            <div class="col-md-12 mb-2">
                                <label>&nbsp;</label>
                                <br>
                                <button type="submit" @click.prevent="paginatedData"
                                        class="btn btn-primary glow mb-1 mb-sm-0">Apply Filter
                                </button>
                                <button type="reset" @click.prevent="resetFilters"
                                        class="btn btn-warning glow mb-1 mb-sm-0">
                                    Reset Filter
                                </button>
                            </div>
                        </div>
                    </form>
                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        :sort-options="sortingOptions"
                        @on-page-change="this.onPageChange"
                        @on-per-page-change="this.onPerPageChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allAdmins"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'email'">
                                <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
                            </span>
                            <span v-else-if="props.column.label === 'Name'">
                               <a :href="route('admin.admins.show', props.row.id)">{{
                                       props.row.first_name + ' ' + props.row.last_name
                                   }}</a>
                            </span>
                            <table-row-actions v-else-if="props.column.field === 'action' && canManageRow(props.row)">
                                <Link v-if="$page.props.can.edit_admin" :href="route('admin.admins.edit', props.row.id)" class="dropdown-item">
                                    <i class="feather icon-edit"></i>
                                    Edit
                                </Link>
                                <a v-if="$page.props.can.edit_admin" href="#" class="dropdown-item" @click.prevent="mfaAlert(props.row.id)">
                                    <i class="feather icon-unlock"></i>
                                    Disable 2FA
                                </a>
                                <a v-if="$page.props.can.delete_admin" href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger">
                                    <i class="feather icon-trash-2"></i>
                                    Delete
                                </a>
                            </table-row-actions>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import PaginationMixin from "../../Shared/Mixins/PaginationMixin";
import {Link} from '@inertiajs/vue2'
import DeleteAlert from "../../Shared/Mixins/DeleteAlert";
import TableExportMixin from "../../Shared/Mixins/TableExportMixin";

export default {
    metaInfo: {title: 'Admin'},
    props: ['admins', 'stores',],
    layout: Layout,
    components: {
      Link,
    },
    mixins: [
        DeleteAlert,
        PaginationMixin,
        TableExportMixin,
    ],
    data: () => ({
        filters: {
            name: null,
            store: null,
            email: null,
        },
        errors: {},
        isLoadingFilter: false,
        allAdmins: [],
        exportRows: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10,
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },

        sortingOptions: {
            enabled: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Email', field: 'email'},
            {label: 'Store Name', field: 'store.name'},
            {label: 'Role', field: 'role'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
    }),
    computed: {
        exportFields() {
            return this.buildExportFieldsFromColumns(this.columns);
        },
    },
    mounted() {
        this.allAdmins = this.admins.data;
        this.totalRecords = this.admins.total
    },
    methods: {
        canManageRow(row) {
            if (row.role === 'super admin' && !this.$page.props.is_super_admin) {
                return false;
            }

            return !!(this.$page.props.can.edit_admin || this.$page.props.can.delete_admin);
        },
        async paginatedData() {
            try {
                let routeName = 'admin.admins.index';

                let response = await axios.get(route(routeName), {
                    params: {
                        page: this.serverParams.page,
                        per_page: this.serverParams.perPage,
                        api: true,
                        ...this.filters
                    },
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                    },
                });

                this.totalRecords = response.data.total;
                this.paginationOptions.perPage = response.data.per_page;
                this.serverParams.perPage = response.data.per_page;
                this.paginationOptions.setCurrentPage = response.data.page;
                this.allAdmins = response.data.data
            } catch (e) {
                console.log(e);
            }
        },
        async resetFilters() {
            for (let filter in this.filters) {
                this.filters[filter] = null;
            }
            await this.paginatedData();
        },
        async showAlert(adminId) {
            const details = {
                title: "Are you sure you want to delete this admin?",
                text: "You won't be able to revert this!",
            }
            await this.deleteAlert(details.title, details.text) ? this.deleteAdmin(adminId) : "";
        },
        async deleteAdmin(id) {
            this.$inertia.delete(route('admin.admins.delete', id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.paginatedData();
                }
            })
        },
        async disable2fa(id) {
            await this.$inertia.delete(route('admin.admins.disable-2fa', id), {
                preserveScroll: true,
                onSuccess: async () => {
                    await this.paginatedData();
                }
            })
        },
        async disable2faAlert(title, text, showCancelButton = true, confirmButtonColor = "#3085d6", cancelButtonColor = "#d33", confirmButtonText = "Yes, disable for this user!", cancelButtonText = "Cancel") {
            return this.$swal.fire({
                title,
                text,
                type: "warning",
                showCancelButton,
                confirmButtonColor,
                confirmButtonText,
                cancelButtonColor,
                cancelButtonText,
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                return !!result.value;
            });
        },
        async mfaAlert(adminId) {
            const details = {
                title: "Are you sure you want to disable 2FA for this user?",
                text: "You won't be able to revert this!",
            }

            await this.disable2faAlert(details.title, details.text) ? await this.disable2fa(adminId) : "";
        },
    }
}
</script>
